export class Cms {
  public _id: string;
  public id: string;
  public title: string;
  public innerHtml: string;
  public isActive: boolean;
  public isHomePage: boolean;
  public subPages: Array<SubPage>;
  public isOnlySubPage: boolean;
  public isShowSubpages: boolean;
  public owners: Array<UserCredential>;
  public contributors: Array<UserCredential>;
  public companyCode: string = '1';
}

export class UserCredential {
  public accountId: string;
  public userName: string;
}

export class SubPage {
  public title: string;
  //public innerHtml: string;
  public isActive: boolean;
  public _id: string;
  //public superParent_id: string;
  //public subPages: Array<SubPage>;
  public owners: Array<UserCredential>;
  public contributors: Array<UserCredential>;
  public orderId: number;

  public updateValues(newSubPage: SubPage) {
    this.title = newSubPage.title;
    //this.innerHtml = newSubPage.innerHtml;
  }
}

export var accountTemplate = '<p><div style="width: 100%;height:auto;display:inline-block">accountTemplateCol</div></p>';

export var accountTemplateCol = '<div style="width: calc(33% - 15px);float: left;box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);border-radius: 5px; margin-right: 15px">' +
  '<div style="padding: 33px 38px;">' +
  '<div style="font-family: Roboto;font-style: normal;font-weight: 300;line-height: normal;font-size: 18px;color: #2F3238;">' +
  'Title 1' +
  '</div>' +
  '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: 13px;font-size: 9px;color: #808080;">' +
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vestibulum ex nec eleifend luctus. Nam.' +
  '</div>' +
  '<div style="margin-top: 30px">' +
  '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: normal;font-size: 10px; color: #2F3238; margin-bottom: 20px">' +
  'Option 1' +
  '</div>' +
  '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: normal;font-size: 10px;color: #2F3238; margin-bottom: 20px">' +
  'Option 2' +
  '</div>' +
  '<div style="font-family: Roboto;font-style: normal;font-weight: normal;line-height: normal;font-size: 10px;color: #2F3238;">' +
  'Option 3' +
  '</div>' +
  '</div>' +
  '</div>' +
  '</div>';

export class Template {
  public name: string;
  public innerHtml: string;
}
